import { useEffect, useState } from 'react'
import SubscriptionService from '@/modules/base/components/subscription/subscriptionService'
import { isMeinBuero } from '@/utils/build-env'

export default function useSubscriptionProducts() {
  const [subscriptionProducts, setSubscriptionProducts] = useState({})
  const [subscriptionProductsStatus, setSubscriptionProductsStatus] = useState<null | 'loading' | 'done'>(null)

  useEffect(() => {
    if (isMeinBuero()) {
      setSubscriptionProductsStatus('loading')
      SubscriptionService.getProductsMbo()
        .then(res => {
          setSubscriptionProducts(res.data)
        }).finally(() => {
          setSubscriptionProductsStatus('done')
        })
    }
  }, [])

  return { subscriptionProducts, subscriptionProductsStatus }
}
